import { BaseModel } from "model/BaseModel";

export default class InspecaoQualidade implements BaseModel {
    id: number;
    codigo: string = "";
    codigoInterno: string;
    descricao: string;
    valorAlvo: number;
    valorMinimo: number;
    valorMaximo: number;
    tipoResultado: string;

    constructor(
        id: number = 0,
        codigoInterno: string = "",
        descricao: string = "",
        valorAlvo: number = 0,
        valorMinimo: number = 0,
        valorMaximo: number = 0,
        tipoResultado: string = ""
    ) {
        this.id = id;
        this.codigoInterno = codigoInterno;
        this.descricao = descricao;
        this.valorAlvo = valorAlvo;
        this.valorMinimo = valorMinimo;
        this.valorMaximo = valorMaximo;
        this.tipoResultado = tipoResultado;
    }
}